import React from 'react';
const ModalContext = React.createContext<any | null>(
    {
        component: null,
        props: {},
        showModal: () => { },
        hideModal: () => { }
    }
);
export default ModalContext;